var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39902_58274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.78407 5.26367C7.19623 5.26367 6.75 5.7246 6.75 6.25623C6.75 6.67045 6.41421 7.00623 6 7.00623C5.58579 7.00623 5.25 6.67045 5.25 6.25623C5.25 4.86308 6.40128 3.76367 7.78407 3.76367C9.16686 3.76367 10.3181 4.86308 10.3181 6.25623C10.3181 7.21072 9.77392 8.0307 8.99094 8.44836C8.78202 8.5598 8.66802 8.63626 8.60056 8.70889C8.5727 8.73888 8.55924 8.762 8.55142 8.78106C8.54396 8.79925 8.53407 8.83196 8.53407 8.89083V9.49172C8.53407 9.90594 8.19829 10.2424 7.78407 10.2424C7.36986 10.2424 7.03407 9.90664 7.03407 9.49243V8.89083C7.03407 7.81322 7.8637 7.34959 8.28497 7.12488C8.61045 6.95126 8.81814 6.62226 8.81814 6.25623C8.81814 5.7246 8.37191 5.26367 7.78407 5.26367ZM8.01094 12.4516C8.45277 12.4516 8.81094 12.0934 8.81094 11.6516C8.81094 11.2097 8.45277 10.8516 8.01094 10.8516C7.56911 10.8516 7.21094 11.2097 7.21094 11.6516C7.21094 12.0934 7.56911 12.4516 8.01094 12.4516Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39902_58274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuide);
export default __webpack_public_path__ + "static/media/ic_guide.8e2221915acc2241623946944ba1b128.svg";
export { ForwardRef as ReactComponent };